import { createSlice } from '@reduxjs/toolkit';

import { TAgentResponse } from '@/types/agents';

export interface IAgentsReducer {
  agents: TAgentResponse;
}

const initialState = {
  agents: {
    items: [],
    pagination: {
      page: 1,
      limit: 5,
      totalPages: 1,
    },
  },
} as unknown as IAgentsReducer;

export const agentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    setAgents: (state, action) => {
      state.agents = action.payload;
    },
    deleteAgentFromList: (state, action) => {
      state.agents.items = state.agents.items.filter(
        (agent) => agent.referenceId !== action.payload
      );
    },
  },
});

export const { setAgents, deleteAgentFromList } = agentsSlice.actions;
